class LightboxVideo extends HTMLElement {
    lightboxSelectors = {
        carousel: '.video-casousel__slideshow',
        arrowNext: '.swiper-button-next',
        arrowPrev: '.swiper-button-prev',
        multiVideoItem: '.multi-videos-item__container',
        multiVideoAction: '.multi-videos-item__action',
        closeLightbox: '.lightbox-video__close',
        dataLightBoxId: 'data-lightbox-video-id',
        dataVideoIndex: 'data-video-index',
        thumbnailButton: '.js-video-player-thumbnail-button',
        dataVideoCarouselIndex: 'data-video-carousel-index',
        lightboxWrapper: '.lightbox-video__wrapper'
    }

    constructor() {
        super();

        const sectionId = this.getAttribute('data-section-id')
        this.lightboxSelectors.carousel = '#' + sectionId + ' ' + this.lightboxSelectors.carousel
        this.lightboxSelectors.arrowNext = '#' + sectionId + ' ' + this.lightboxSelectors.arrowNext
        this.lightboxSelectors.arrowPrev = '#' + sectionId + ' ' + this.lightboxSelectors.arrowPrev
        this.lightboxSelectors.multiVideoItem = '#' + sectionId + ' ' + this.lightboxSelectors.multiVideoItem
        this.lightboxSelectors.multiVideoAction = '#' + sectionId + ' ' + this.lightboxSelectors.multiVideoAction
        this.lightboxSelectors.closeLightbox = '#' + sectionId + ' ' + this.lightboxSelectors.closeLightbox
        this.lightboxSelectors.lightboxWrapper = '#' + sectionId + ' ' + this.lightboxSelectors.lightboxWrapper

        this.carouselSlide = this.querySelector(this.lightboxSelectors.carousel);

        this.showLightbox()
        this.hideLightbox()
    }

    showLightbox() {
        const videos = document.querySelectorAll(this.lightboxSelectors.multiVideoItem)
        videos.forEach(video => {
            const videoAction = video.querySelector(this.lightboxSelectors.multiVideoAction)
            if (!videoAction) return

            videoAction.addEventListener('click', () => {
                const id = videoAction.getAttribute(this.lightboxSelectors.dataLightBoxId)
                const index = videoAction.getAttribute(this.lightboxSelectors.dataVideoIndex)
                const lightbox = document.getElementById(id)
                const body = document.querySelector('body')
                const button = lightbox.querySelector(
                    `[${this.lightboxSelectors.dataVideoCarouselIndex}="${index}"] ${this.lightboxSelectors.thumbnailButton}`
                );
                if (lightbox && body && button) {
                    this.initCarousel(index)
                    setTimeout(() => {
                        lightbox.style.display = 'block'
                        body.style.overflow = 'hidden'
                    }, 300)
                }
            })
        })
    }

    hideLightbox() {
        const closeEl = document.querySelector(this.lightboxSelectors.closeLightbox)
        if (!closeEl) return

        closeEl.addEventListener('click', () => {
            const lightbox = closeEl.closest(this.lightboxSelectors.lightboxWrapper)
            const body = document.querySelector('body')
            if (lightbox && body) {
                lightbox.style.display = 'none'
                body.style.overflow = 'auto'
            }
        })
    }

    initCarousel(index) {
        const swiper = new Swiper(this.carouselSlide, {
            slidesPerView: 1,
            spaceBetween: 0,
            init: false,
            loop: false,
            speed: 500,
            freeMode: {
                enabled: true,
                sticky: true
            },
            navigation: {
                nextEl: this.lightboxSelectors.arrowNext,
                prevEl: this.lightboxSelectors.arrowPrev
            }
        });

        swiper.init()
        setTimeout(() => {
            swiper.slideTo(index - 1)
        }, 300)
    }
}
if (!customElements.get('lightbox-video')) {
    customElements.define("lightbox-video", LightboxVideo);
}

